import {
  ShieldCheckIcon,
  ClipboardDocumentCheckIcon,
  HeartIcon,
} from "@heroicons/react/20/solid";
import medreviewImg from "./top-view-pills-making-heart.jpg";
import { FaCapsules, FaBoxOpen, FaBell, FaRecycle } from "react-icons/fa"; // Import icons
import { Link } from "react-router-dom";

const features = [
  {
    name: "Walk-In Anytime.",
    description:
      "No appointment needed—just visit us during pharmacy hours to get vaccinated quickly and easily.",
    icon: ClipboardDocumentCheckIcon, // Replaced SyringeIcon
  },
  {
    name: "Flu & COVID-19 Shots Available.",
    description:
      "Protect yourself and your loved ones. Flu and COVID-19 vaccines do not require a prescription—get yours today!",
    icon: ShieldCheckIcon,
  },
  {
    name: "Quick & Hassle-Free.",
    description:
      "Get your vaccination in minutes without the long wait times at a doctor's office.",
    icon: HeartIcon,
  },
];

export default function SplitInfoSection() {
  return (
    <div className="relative overflow bg-white py-6">
      <div
        className="absolute bg-[#e2c6ae] w-[50%] h-[100%] rounded-xl shadow-lg hidden lg:block bg-cover bg-center"
        style={{
          backgroundImage: `url(${medreviewImg})`,
        }}
      >
        <p
          className="absolute top-[35%] left-[77%] transform -translate-x-1/2 -translate-y-1/2 text-2xl sm:text-2xl lg:text-3xl xl:text-4xl font-semibold tracking-tight text-white  
  drop-shadow-lg"
        >
          Ontario Pharmacists Can Vaccinate!
        </p>
        <Link
          to="/vaccination"
          className="absolute z-50 top-[65%] left-[67%] transform -translate-x-1/2 -translate-y-1/2 mt-6 inline-block text-white font-semibold hover:underline"
        >
          See all our available vaccines →
        </Link>
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-center">
          <div className="flex-2 relative h-full justify-center lg:justify-start hidden lg:block "></div>

          <div className="flex-1 lg:pl-16 flex flex-col justify-center">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold text-[#f49988]">
                We Make Healthcare Convenient for You
              </h2>
              <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">
                We Do It All!
              </p>
              <ul className="mt-6 space-y-8 text-base text-gray-600">
                {/* Free Medication Check */}
                <li className="relative pl-9">
                  <span className="inline font-semibold text-gray-900">
                    <FaCapsules
                      aria-hidden="true"
                      className="absolute top-1 left-1 w-5 h-5 text-[#e2c6ae]"
                    />
                    Free Medication Check
                  </span>
                  <p className="mt-2">
                    Ensure your medications are working for you with a free
                    consultation.{" "}
                    <Link
                      to="/about#medication-review"
                      className="text-[#f49988] hover:underline"
                    >
                      more.
                    </Link>
                  </p>
                </li>

                {/* Blister Packaging */}
                <li className="relative pl-9">
                  <span className="inline font-semibold text-gray-900">
                    <FaBoxOpen
                      aria-hidden="true"
                      className="absolute top-1 left-1 w-5 h-5 text-[#e2c6ae]"
                    />
                    Blister Packaging
                  </span>
                  <p className="mt-2">
                    Stay organized with customized blister packaging for your
                    prescriptions.{" "}
                    <Link
                      to="/about#compliance-aids"
                      className="text-[#f49988] hover:underline"
                    >
                      more.
                    </Link>
                  </p>
                </li>

                {/* Refill Reminders */}
                <li className="relative pl-9">
                  <span className="inline font-semibold text-gray-900">
                    <FaBell
                      aria-hidden="true"
                      className="absolute top-1 left-1 w-5 h-5 text-[#e2c6ae]"
                    />
                    Refill Reminders
                  </span>
                  <p className="mt-2">
                    Never miss a dose with automatic prescription refill
                    reminders.{" "}
                    <Link
                      to="/about#refill-reminders"
                      className="text-[#f49988] hover:underline"
                    >
                      more.
                    </Link>
                  </p>
                </li>

                {/* Sharps Disposal */}
                <li className="relative pl-9">
                  <span className="inline font-semibold text-gray-900">
                    <FaRecycle
                      aria-hidden="true"
                      className="absolute top-1 left-1 w-5 h-5 text-[#e2c6ae]"
                    />
                    Sharps Disposal
                  </span>
                  <p className="mt-2">
                    Safe and responsible disposal of used needles and sharps.{" "}
                    <Link
                      to="/about#sharps-disposal"
                      className="text-[#f49988] hover:underline"
                    >
                      more.
                    </Link>
                  </p>
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="flex-2 relative h-full justify-center lg:justify-start lg:hidden">
            <img
              alt="Pharmacist providing care"
              src={medreviewImg}
              width={2432}
              height={1442}
              className="relative w-full bottom-0 max-w-full rounded-xl shadow-lg sm:max-w-full md:max-w-full lg:max-w-full ring-gray-400/10"
            />
          </div> */}
          {/* <div
            className="relative bg-[#e2c6ae] w-[100%] h-[25rem] rounded-xl shadow-lg  lg:hidden bg-cover bg-center"
            style={{
              backgroundImage: `url(${medreviewImg})`,
            }}
          >
            <p
              className="relative top-[35%] left-[75%] transform -translate-x-1/2 -translate-y-1/2 
  text-4xl font-semibold tracking-tight text-white sm:text-5xl 
  drop-shadow-lg"
            >
              Ontario Pharmacists Can Vaccinate!
            </p>
            <Link
              to="/vaccination"
              className="absolute z-50 top-[65%] left-[67%] transform -translate-x-1/2 -translate-y-1/2 mt-6 inline-block text-white font-semibold hover:underline"
            >
              See all our available vaccines →
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
}
